import { put, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { setRtsSysBpOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptions } from '../../../common/common.types'

export function* getRtsSysBpOptions() {
  try {
    const entity: IOptions = [
      { id: 0, name: '0' },
      { id: 1, name: '1-49' },
      { id: 2, name: '50-75' },
      { id: 3, name: '76-89' },
      { id: 4, name: '> 89' },
    ]
    yield put(setRtsSysBpOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getRtsSysBpOptions() error: ${e}`))
  }
}
export function* getRtsSysBpOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getRtsSysBpOptions)
}
